import { Button, Divider } from '@mui/material';
import { useMount } from 'ahooks';
import classNames from 'classnames';
import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { implog } from '@/api/implog';
import { fetchIpaAward } from '@/api/user';
import showNiceModal from '@/components/nice-modal';
import BlurryLoadingImage from '@/components/progressive-img';
import { ACCESS_TOKEN_KEY, ACCESS_USER_NAME, ACCESS_USERID_KEY } from '@/constant/config';
import CheckedIcon from '@/modules/ipa-task/assets/checked_icon.webp';
import help_bg from '@/modules/ipa-task/assets/help_bg.webp';
import modal_header_bg from '@/modules/ipa-task/assets/modal_header_bg.webp';
import { modalStore } from '@/stores/modal';
import globalStore from '@/stores/store';
import { isInIPA, openInBrowser } from '@/utils/apk';
import Storage from '@/utils/Storage';
import { toast } from '@/utils/toast';
import { inPwaEnv } from '@/utils/utils';

import styles from './styles.module.less';

const IPATask = ({ needHelp = false }) => {
  const { pathname } = useLocation();
  useMount(() => {
    implog('bonus_ipa_task_show', { inIpa: isInIPA(), inPwa: inPwaEnv(), pathname });
  });
  return (
    <div className={styles.task}>
      <div className={styles.task_item}>
        <div className={styles.task_item_index}>1</div>
        <div className={styles.task_item_content}>
          <div className={styles.task_item_title}>Bind your phone number</div>
          <div className={styles.task_item_opt}>
            {globalStore?.initialState?.is_bind_mobile ? (
              <BlurryLoadingImage src={CheckedIcon} alt="check" />
            ) : (
              <Button
                sx={{
                  height: '0.6rem',
                  fontSize: '0.28rem',
                  lineHeight: '0.33rem',
                  borderRadius: '0.9rem'
                }}
                className="global_button_succes"
                onClick={() => {
                  implog('bonus_ipa_task_bind_click', { inIpa: isInIPA(), inPwa: inPwaEnv(), pathname });
                  modalStore.openBindPhone({ from: 'ipa' });
                }}
              >
                Bind
              </Button>
            )}
          </div>
        </div>
      </div>
      <Divider className={styles.divider}></Divider>
      <div
        className={classNames(styles.task_item, {
          [styles.task_item_disabled]: !globalStore?.initialState?.is_bind_mobile
        })}
      >
        <div className={styles.task_item_index}>2</div>
        <div className={styles.task_item_content}>
          <div className={styles.task_item_title}>
            Add to home screen{' '}
            {needHelp ? (
              <span
                onClick={() => {
                  showNiceModal({
                    maskClosable: true,
                    width: '6rem',
                    contentStyle: {
                      background: 'var(--backgroundColor)',
                      borderRadius: '0.4rem',
                      padding: '0.45rem'
                    },
                    render: () => {
                      return <BlurryLoadingImage src={help_bg} />;
                    }
                  });
                }}
              >
                ?
              </span>
            ) : (
              ''
            )}
          </div>
          <div className={styles.task_item_opt}>
            {inPwaEnv() ? (
              <BlurryLoadingImage src={CheckedIcon} alt="check" />
            ) : (
              <Button
                sx={{
                  height: '0.6rem',
                  fontSize: '0.28rem',
                  lineHeight: '0.33rem',
                  borderRadius: '0.9rem'
                }}
                className="global_button_succes"
                onClick={async () => {
                  if (!globalStore?.initialState?.is_bind_mobile) {
                    return;
                  }
                  implog('bonus_ipa_task_add_click', { inIpa: isInIPA(), inPwa: inPwaEnv(), pathname });
                  if (isInIPA()) {
                    /**
                     * 加密jwt参数，加解密的算法是对json进行base64编码
                     */
                    const userid = Storage.getAccess(ACCESS_USERID_KEY);
                    const username = Storage.getAccess(ACCESS_USER_NAME);
                    const token = Storage.getAccess(ACCESS_TOKEN_KEY);
                    const sourceurl = localStorage.getItem('us_game_unique_key');
                    const machineserial = await getUniqueID();
                    const jwt = JSON.stringify({
                      userid: userid,
                      username: username,
                      channel: getAPKCHSource(),
                      token: token,
                      sourceurl,
                      machineserial,
                      type: 1
                    });
                    const encodedJwt = btoa(jwt);
                    const url = `${
                      window.location.origin
                    }/${getAPKCHSource().toLocaleLowerCase()}/000000/game?jwt=${encodedJwt}`;
                    openInBrowser(url);
                    return;
                  }
                  modalStore.openPwaModal({ from: 'ipa' });
                }}
              >
                Add
              </Button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export const WithdrawIpaTask = () => {
  return (
    <div className={styles.withdraw_task}>
      <div className={styles.withdraw_task_title}>&nbsp;&nbsp;Complete 2 steps to withdraw</div>
      <IPATask />
    </div>
  );
};

export const IpaTaskModal = (modal, onClose) => {
  useEffect(() => {
    implog('wa_activate_progress_show');
  }, []);
  const [loading, setLoading] = useState(false);
  return (
    <div className={styles.ipa_modal_container}>
      <div className={styles.ipa_modal_header}>
        <BlurryLoadingImage divStyleClass={styles.activate_header} src={modal_header_bg} alt="" />
        <div className={styles.ipa_modal_header_desc}>Get it after completing the task</div>
      </div>
      <div className={styles.ipa_modal_body}>
        <div className={styles.modal_task}>
          <IPATask needHelp />
        </div>
        {globalStore?.userInfo?.ios_super ? null : (
          <Button
            className={
              globalStore?.initialState?.is_bind_mobile && inPwaEnv() && !loading
                ? 'global_button_succes'
                : 'global_button_disabled'
            }
            sx={{
              width: '3.03rem',
              height: '0.8rem',
              fontSize: '0.32rem',
              fontWeight: 700,
              borderRadius: '0.4rem',
              display: 'block',
              margin: '0.3rem auto'
            }}
            variant="text"
            onClick={async () => {
              if (loading) return;
              if (!(globalStore?.initialState?.is_bind_mobile && inPwaEnv())) return;
              setLoading(true);
              implog('bonus_ipa_task_claim_click');
              try {
                await fetchIpaAward();
                toast(
                  <div style={{ width: '100%', padding: '0.3rem', textAlign: 'center' }}>
                    <div>You&apos;ve Received</div>
                    <div
                      className={styles.price_title}
                      style={{
                        color: '#ffd118',
                        fontSize: '0.35rem',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        marginTop: '0.2rem'
                      }}
                    >
                      $ 10
                    </div>
                  </div>
                );
                await globalStore.fetchBalance();
                modal?.resolve({ onClose });
              } catch (error) {
                /* empty */
              }
            }}
          >
            Claim Bonus
          </Button>
        )}
      </div>
    </div>
  );
};
